import { FC, PropsWithChildren } from "react";
import styles from "./DashboardNavCard.module.scss";
import cn from "classnames";
import { NavContext } from "../NavContext";

/**
 * Indicates that the child navigation card be styled as a dashboard nav card.
 */
export const DashboardNavCard: FC<PropsWithChildren<{}>> = ({ children }: PropsWithChildren<{}>) => {
  const className = cn(styles.dashboardNavCard, "dashboard-nav-card");
  return (
    <NavContext.Provider value="dashboard">
      <div className={className}>{children}</div>
    </NavContext.Provider>
  );
};
